import { useRouter } from 'next/router';
import { useLogoutCustomer } from 'hooks';
import cn from 'classnames';
import { addLocaleToHref } from 'lib/utils/helpers';
import styles from './navigationSideBar.module.scss';

const NavigationSideBar = ({
  locale,
  customer,
  navTracker,
  setNavTracker,
  setShowDetails,
  setAddToggleForm,
  setUpdateToggleForm,
  accountpagenavigation,
}) => {
  const router = useRouter();
  const {
    navigationDashboard,
    navigationOrders,
    navigationPersonalInfo,
    navigationAddressBook,
    navigationLogout,
    navigationLoggingOutMessage,
  } = accountpagenavigation;

  // const [toggleAddForm, setAddToggleForm] = useState(false);
  // const [toggleDeleteAddress, setToggleDeleteAddress] = useState(false);
  // const [toggleUpdateForm, setUpdateToggleForm] = useState(false);

  const [logoutCustomer, { loading, response, error }] = useLogoutCustomer(locale);
  const handleLogout = async e => {
    e.preventDefault();
    await logoutCustomer(customer.customerAccessToken.accessToken);
  };

  const emptyOrders =
    customer.orders && !customer.orders.edges.length >= 1 && navTracker === 'orders';

  return (
    <div className={cn(styles.container, emptyOrders && styles.addMarginBottom)}>
      <button
        type="button"
        className={cn(styles.navigationLink, navTracker === 'dashboard' && styles.active)}
        onClick={() => {
          router.push(addLocaleToHref(`/account/dashboard/`, locale), undefined, { shallow: true });
        }}
      >
        {navigationDashboard?.text}
      </button>
      <button
        type="button"
        className={cn(styles.navigationLink, navTracker === 'orders' && styles.active)}
        onClick={() => {
          router.push(addLocaleToHref(`/account/orders/`, locale), undefined, { shallow: true });
          setShowDetails(false);
        }}
      >
        {navigationOrders?.text}
      </button>
      <button
        type="button"
        className={cn(styles.navigationLink, navTracker === 'personalInfo' && styles.active)}
        onClick={() => {
          router.push(addLocaleToHref(`/account/personalInfo/`, locale), undefined, {
            shallow: true,
          });
        }}
      >
        {navigationPersonalInfo?.text}
      </button>
      <button
        type="button"
        className={cn(styles.navigationLink, navTracker === 'addressBook' && styles.active)}
        onClick={() => {
          router.push(addLocaleToHref(`/account/addressBook/`, locale), undefined, {
            shallow: true,
          });
          setAddToggleForm(false);
          setUpdateToggleForm(false);
        }}
      >
        {navigationAddressBook?.text}
      </button>
      {loading || response ? (
        <button type="button" className={styles.navigationLink}>
          {navigationLoggingOutMessage?.text}
        </button>
      ) : (
        <button type="button" className={styles.navigationLink} onClick={e => handleLogout(e)}>
          {navigationLogout?.text}
        </button>
      )}
      {error && <span>Problem logging out</span>}
    </div>
  );
};

export default NavigationSideBar;
